import { sendTransaction } from '@wagmi/core';
import { toTransferError } from "./toTransferError";
import { resolveWalletConnector } from '../service/resolveWalletConnector';
export function createEVMTransferProvider(config, supportsNetwork, buildTransaction) {
    return {
        supportsNetwork,
        async executeTransfer(params) {
            const { selectedWallet } = params;
            try {
                const tx = await buildTransaction(params);
                const connector = resolveWalletConnector(config, selectedWallet);
                const hash = await sendTransaction(config, { ...tx, connector });
                if (hash) {
                    return hash;
                }
                throw new Error("No transaction hash returned");
            }
            catch (error) {
                throw toTransferError(error);
            }
        }
    };
}
